import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=cd00c8e0&"
import script from "./GroupPanel.vue?vue&type=script&lang=js&"
export * from "./GroupPanel.vue?vue&type=script&lang=js&"
import style0 from "./GroupPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports